import { getDefaultRichTextEditorData } from 'utils';
import { DEFAULT_GATE_TITLE, DEFAULT_GATE_SUBTITLE } from 'shared/constants';
import { MAESTRO_WHITE } from 'style/constants';
import { injectT } from 'hooks/use-translation';
import { getDefaultEditorState, getDefaultTextNode } from 'components/ui/RichTextEditorV3/getDefaultEditorState';

export const getTitleData = injectT(
  (t) => (
    title: string,
    titleRawData: string,
    titleRawDataV2: string,
    isRichTextEditorV3Enabled: boolean,
    contentTextColor: string) => {
    if (titleRawDataV2) {
      return titleRawDataV2;
    }

    // Styled Data
    if (titleRawData) {
      return titleRawData;
    }

    if (isRichTextEditorV3Enabled) {
      return getDefaultEditorState([
        getDefaultTextNode({
          text: title || '',
          fontSize: 30,
        }),
      ]);
    }

    // Default Data
    return getDefaultRichTextEditorData({
      text: title || '',
      color:
        title === DEFAULT_GATE_TITLE(t) ? MAESTRO_WHITE : contentTextColor,
      fontSize: 30,
    });
  },
);

export const getSubtitleData = injectT(
  (t) => (
    subtitle: string,
    subtitleRawData: string,
    subtitleRawDataV2: string,
    isRichTextEditorV3Enabled: boolean,
    contentTextColor: string,
    ) => {
    if (isRichTextEditorV3Enabled) {
      return subtitleRawDataV2;
    }

    // Styled Data
    if (subtitleRawData) {
      return subtitleRawData;
    }

    if (isRichTextEditorV3Enabled) {
      return getDefaultEditorState([
        getDefaultTextNode({
          text: subtitle || '',
          fontSize: 14,
        }),
      ]);
    }

    // Default Data
    return getDefaultRichTextEditorData({
      text: subtitle || '',
      color:
        subtitle === DEFAULT_GATE_SUBTITLE(t) ? MAESTRO_WHITE :
        contentTextColor,
      fontSize: 14,
    });
  },
);
